import { formatIdealistDateTime } from './date';

export function isDuplicatePageError(errorDescription: string): boolean {
  return (
    errorDescription.includes('already exists') ||
    errorDescription.includes('ya existe')
  );
}

export function shouldBeScheduled(postedDate: string | Date) {
  return (
    Date.parse(new Date(postedDate).toISOString()) >
    Date.parse(formatIdealistDateTime(new Date()).toISOString())
  );
}
